@if (mappedDefaults?.length) {
  <nb-card>
    <nb-card-header>
      {{ "Defaults" | translate }}
    </nb-card-header>
    <nb-card-body>
      <nb-list>
        @for (default of mappedDefaults; track default; let last = $last;) {
          <nb-list-item>
            <div class="default-row">
              @if (default.gallerySettings.dynamicEl?.length) {
                <lightgallery [settings]="default.gallerySettings" [onInit]="default.onInit"></lightgallery>
                <div class="img-box" (click)="default.openGallery()">
                  <img [src]="default.gallerySettings.dynamicEl[0]?.thumb" class="img-thumbnail">
                </div>
              }
              @if (!default.gallerySettings.dynamicEl?.length) {
                <div class="img-box">
                  <div class="no-img-thumbnail">
                    {{ 'None' | translate }}
                    <br>
                      {{ 'reports.inventory-report.assets-by-perimeter.columns.photo' | translate | lowercase }}
                    </div>
                  </div>
                }
                <div class="default-info mx-4">
                  <!-- DEFAULT LABEL -->
                  <span class="default-label">{{ default.kpi_expert_name }}</span>
                  <!-- DEFAULT AUTHOR -->
                  <span class="default-author">
                    {{ 'pages.insight.asset.default-by' | translate : {userName: default.userName, date: default.date} }}
                  </span>
                </div>
                <!-- DEFAULT COMMMENTS -->
                @if (default.comment) {
                  <fa-icon icon="comment" [nbTooltip]="default.comment" nbTooltipPlacement="right"></fa-icon>
                }
                <!-- <ks-modal-gallery
                  [id]="default.gallegyId"
                  [images]="default.modalPictures"
                  [showGallery]="true"
                  [config]="currentImageConfig"
                  class="hide-default-thumbnails"
                ></ks-modal-gallery> -->
              </div>
              @if (!last) {
                <div class="default-divider"></div>
              }
            </nb-list-item>
          }
        </nb-list>
      </nb-card-body>
    </nb-card>
  }